import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";

// initial state
export const initialState = () => {
  return {
    myClients: {
      list: [],
      pagination: {
        next_page: 1,
        last_page: 1,
        per_page: 8,
        total: 0
      }
    }
  };
};

export default {
  state: initialState(),
  getters,
  mutations,
  actions,
  modules: {}
};
